<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="nav">
<h1 class="title">Contents</h1>
<ol>
<li class="tocfm" id="ncover"><a href="#/cover#cover">Cover</a></li>
<li class="tocfm" id="ntitle-page"><a href="#/title_page#title-page">Title Page</a></li>
<li class="tocfm" id="nde1"><a href="#/Dedication#de1">Dedication</a></li>
<li class="tocfm" id="nep2"><a href="#/Epigraph#ep2">Epigraph</a></li>
<li class="tocnav" hidden="hidden"><a href="#/nav">Contents</a></li>
<li class="tocfm" id="nma3"><a href="#/Map_2#ma3">Map #1</a></li>
<li class="tocfm" id="nma4"><a href="#/Map_3#ma4">Map #2</a></li>
<li class="tocfm" id="nma5"><a href="#/Map_1#ma5">Map #3</a></li>
<li class="tocfm" id="nma6"><a href="#/Map_4#ma6">Map #4</a></li>
<li class="tocbm" id="npr7"><a href="#/Prologue#pr7">Prologue</a></li>
<li class="tocbm" id="nch8"><a href="#/Chapter_1_Hephaestus_Awak#ch8">Chapter 1: Hephaestus Awakes</a></li>
<li class="tocbm" id="nch9"><a href="#/Chapter_2_From_the_Graves#ch9">Chapter 2: From the Graves of Eden</a></li>
<li class="tocbm" id="nch10"><a href="#/Chapter_3_Adaptation#ch10">Chapter 3: Adaptation</a></li>
<li class="tocbm" id="nch11"><span href="#/Chapter_4_Dead_of_Night#ch11" title="Link target outside of Sample">Chapter 4: Dead of Night</span></li>
<li class="tocbm" id="nch12"><span href="#/Chapter_5_Plum_Island_Ris#ch12" title="Link target outside of Sample">Chapter 5: Plum Island Rising</span></li>
<li class="tocbm" id="nch13"><span href="#/Chapter_6_It_Came_from_Be#ch13" title="Link target outside of Sample">Chapter 6: It Came from Beneath the Sea</span></li>
<li class="tocbm" id="nch14"><span href="#/Chapter_7_Lysenko#ch14" title="Link target outside of Sample">Chapter 7: Lysenko</span></li>
<li class="tocbm" id="nch15"><span href="#/Chapter_8_All_the_Remains#ch15" title="Link target outside of Sample">Chapter 8: All That Remains</span></li>
<li class="tocbm" id="nch16"><span href="#/Chapter_9_Seeing_Red#ch16" title="Link target outside of Sample">Chapter 9: Seeing Red</span></li>
<li class="tocbm" id="nch17"><span href="#/Chapter_10_A_Meeting_with#ch17" title="Link target outside of Sample">Chapter 10: A Meeting with Medusa</span></li>
<li class="tocbm" id="nch18"><span href="#/Chapter_11_Secret_Wars#ch18" title="Link target outside of Sample">Chapter 11: Secret Wars</span></li>
<li class="tocbm" id="nch19"><span href="#/Chapter_12_Codes_and_Cons#ch19" title="Link target outside of Sample">Chapter 12: Codes and Conspiracies</span></li>
<li class="tocbm" id="nch20"><span href="#/Chapter_13_What_an_Octopu#ch20" title="Link target outside of Sample">Chapter 13: What an Octopus Knows</span></li>
<li class="tocbm" id="nch21"><span href="#/Chapter_14_Immortal_Sins#ch21" title="Link target outside of Sample">Chapter 14: Immortal Sins</span></li>
<li class="tocbm" id="nch22"><span href="#/Chapter_15_Beyond_the_Spe#ch22" title="Link target outside of Sample">Chapter 15: Beyond the Spectrum</span></li>
<li class="tocbm" id="nch23"><span href="#/Chapter_16_A_Study_in_Sca#ch23" title="Link target outside of Sample">Chapter 16: A Study in Scarlet</span></li>
<li class="tocbm" id="nch24"><span href="#/Chapter_17_Future_Primiti#ch24" title="Link target outside of Sample">Chapter 17: Future Primitive</span></li>
<li class="tocbm" id="nch25"><span href="#/Chapter_18_Chains_of_Comm#ch25" title="Link target outside of Sample">Chapter 18: Chains of Command</span></li>
<li class="tocbm" id="nch26"><span href="#/Chapter_19_Icarus#ch26" title="Link target outside of Sample">Chapter 19: Icarus</span></li>
<li class="tocbm" id="nch27"><span href="#/Chapter_20_Anger_Denial_A#ch27" title="Link target outside of Sample">Chapter 20: Anger, Denial, Acceptance</span></li>
<li class="tocbm_p" id="nep28"><span href="#/Epilogue_The_Descent_of_M#ep28" title="Link target outside of Sample">Epilogue</span><ol>
<li class="tocbm_1" id="npa29"><span href="#/Part_1_Yanni_The_Quest#pa29" title="Link target outside of Sample">Part 1: Yanni: The Quest</span></li>
<li class="tocbm_1" id="npa30"><span href="#/Part_2_The_Darwin_Strain_#pa30" title="Link target outside of Sample">Part 2: The Darwin Strain: Anatomy of a Legend</span></li></ol></li>
<li class="tocbm" id="nau31"><span href="#/Authors_Note_Reality_Chec#au31" title="Link target outside of Sample">Author’s Note</span></li>
<li class="tocrm" id="nac32"><span href="#/Acknowledgments#ac32" title="Link target outside of Sample">Acknowledgments</span></li>
<li class="tocrm" id="nse33"><span href="#/Selected_Bibliography#se33" title="Link target outside of Sample">Selected Bibliography</span></li>
<li class="tocrm" id="nab34"><span href="#/About_the_Authors#ab34" title="Link target outside of Sample">About the Authors</span></li>
<li class="tocrm" id="nca35"><span href="#/Card_Page#ca35" title="Link target outside of Sample">Also by Bill Schutt &amp; J. R. Finch</span></li>
<li class="tocrm" id="nco38"><span href="#/Copyright_electronic#co38" title="Link target outside of Sample">Copyright</span></li>
<li class="tocrm" id="nab39"><span href="#/About_the_Publisher#ab39" title="Link target outside of Sample">About the Publisher</span></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?003162b8